import axiosInstance from '../../../core/services/axiosConfig';
import { apis } from '../../../core/services/params';
import React, { useState, useEffect } from 'react';
import { Spin, message } from 'antd';
import { useNavigate } from 'react-router-dom';

// @@ AI-COMMENT: Props for the phone call details smart opener
interface PhoneCallDetailsModalProps {
    visible: boolean;
    phone?: string;
    onClose: () => void;
}

// @@ AI-COMMENT: Directly fetches the most recent Ozonetel call by phone and navigates to details page — no intermediate list
const PhoneCallDetailsModal: React.FC<PhoneCallDetailsModalProps> = ({ visible, phone, onClose }) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // @@ AI-COMMENT: On open, fetch calls by phone and navigate to the most recent UCID
    useEffect(() => {
        if (!visible || !phone) return;
        setLoading(true);
        // @@ AI-COMMENT: Normalize phone to E164 format: 10-digit → +91XXXXXXXXXX, 12-digit → +XXXXXXXXXXXX, 13-char already formatted
        const digits = (phone || '').replace(/\D/g, '');
        let e164 = phone;
        if (digits.length === 10) {
            e164 = `+91${digits}`;
        } else if (digits.length === 12) {
            e164 = `+${digits}`;
        } else if (phone.length === 13 && phone.startsWith('+')) {
            e164 = phone;
        }
        axiosInstance.post(`${apis.OZONETEL_LIVE_REPORT}?page=1&per_page=5`, {
            filters: {
                // @@ AI-COMMENT: E164 uses the normalized phone number
                E164: e164,
                Agent: '', AgentStatus: '', CampaignName: '',
                DialStatus: '', HangupBy: '', Status: '', UCID: '',
                start_date: '', end_date: '',
            }
        }).then(res => {
            const calls: any[] = res.data?.data || [];
            if (calls.length > 0) {
                navigate(`/crm/ozonetel-call-track/${calls[0].UCID}`);
            } else {
                message.info('No call records found for this phone number.');
            }
            onClose();
        }).catch(() => {
            message.error('Failed to fetch call records.');
            onClose();
        }).finally(() => {
            setLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible, phone]);

    // @@ AI-COMMENT: Show a brief fullscreen spinner while fetching the UCID
    if (visible && loading) {
        return (
            <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
                <div className="bg-white rounded-xl p-6 flex flex-col items-center gap-3 shadow-xl">
                    <Spin size="large" />
                    <p className="text-sm text-gray-500">Fetching call details...</p>
                </div>
            </div>
        );
    }

    return null;
};

export default PhoneCallDetailsModal;
